import { render, staticRenderFns } from "./SolicitudesPantalla.vue?vue&type=template&id=2acca3a0&"
import script from "./SolicitudesPantalla.vue?vue&type=script&lang=ts&"
export * from "./SolicitudesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2acca3a0', component.options)
    } else {
      api.reload('2acca3a0', component.options)
    }
    module.hot.accept("./SolicitudesPantalla.vue?vue&type=template&id=2acca3a0&", function () {
      api.rerender('2acca3a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Solicitudes/SolicitudesPantalla.vue"
export default component.exports